import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
    {
        path: '/purchase-order=:token',
        component: () => import('@/website'),
        children: [
            {
                path: '/purchase-order=:token', component: () => import(/* webpackChunkName: "purchase-order" */ '@/website/purchase_order'),
                meta: { title: 'Purchase Order' }
            },
            {
                path: '/tracking', component: () => import(/* webpackChunkName: "purchase-order" */ '@/website/tracking'),
                meta: { title: 'เช็คสถานะ' }
            },
        ]
    },
    {
        path: '/order-detail',
        component: () => import('@/website/order_detail'),
        props: route => ({ query: route.query.q })
        // children: [
        //     {
        //         path: '/order-detail=:token', component: () => import(/* webpackChunkName: "purchase-order" */ '@/website/order_detail'),
        //         meta: { title: 'Purchase Order' }
        //     },
        //
        // ]
    },
    {
        path: '',
        component: () => import('@/website'),
        children: [
            {
                path: '', component: () => import(/* webpackChunkName: "purchase-order" */ '@/website/tracking'),
                meta: { title: 'เช็คสถานะ' }
            },
        ]
    },
    { path: '/error', component: () => import(/* webpackChunkName: "error" */ '@/website/Error'), meta: { title: 'error' } },
    { path: '*', component: () => import(/* webpackChunkName: "error" */ '@/website/Error'), meta: { title: 'error' } },
]

const router = new Router({
    linkActiveClass: 'active',
    routes,
    mode: 'history'
})

export default router
